import React from 'react';
import PropTypes from 'prop-types';
import singleMessage from '../SingleMessage/SingleMessage';
import CTASingleCard from '../CTASingleCard/CTASingleCard';
import PartnersList from '../PartnersList/PartnersList';
import PeopleList from '../PeopleList/PeopleList';
import Cards from '../Cards/Cards';
import CTAMultiCard from '../CTAMultiCard/CTAMultiCard';
import IframeBlock from '../IframeBlock/IframeBlock';
import NewsBlock from '../NewsBlock/NewsBlock';
import DonateBanner from '../DonateBanner/DonateBanner';
import DescriptorBlock from '../DescriptorBlock/DescriptorBlock';
import BiteSize from '../BiteSize/BiteSize';
import ParagraphHTML from '../ParagraphHTML/ParagraphHTML';
import ImpactSlider from '../ImpactSlider/ImpactSlider';
import ParagraphMap from '../ParagraphMap/ParagraphMap';
import WYMDCarousel from '../WYMDCarousel/WYMDCarousel';
import RichtextCarousel from '../RichtextCarousel/RichtextCarousel';
import HeroBanner from '../HeroBanner/HeroBanner';
import DynamicGallery from '../DynamicGallery/DynamicGallery';
import QuoteSlice from '../QuoteSlice/QuoteSlice';
import StatsSlice from '../StatsSlice/StatsSlice';
import EmailBanner from '../EmailBanner/EmailBanner';

const Paragraphs = (props) => {
  const {
    paragraphs,
    partners = null,
    people = null,
    articles = null,
    moneyBuys = null,
    descriptors = null
  } = props;
  return paragraphs.map((paragraph, index) => {
    const key = `paragraph-${paragraph.id ? paragraph.id : index}`;
    const category = paragraph.featuredCategory && paragraph.featuredCategory.title;

    /* eslint no-underscore-dangle: 0 */
    switch (paragraph.__typename) {
      case 'ContentfulDonateBanner': {
        return <DonateBanner donateBanner={paragraph} moneyBuys={moneyBuys} key={key} />;
      }
      case 'ContentfulPartnersList': {
        return <PartnersList partnersList={partners} data={paragraph} key={key} />;
      }
      case 'ContentfulPeopleList': {
        return <PeopleList people={people} key={key} />;
      }
      case 'ContentfulParagraphCards': {
        return <Cards data={paragraph} key={key} />;
      }
      case 'ContentfulCtaMultiCard': {
        return <CTAMultiCard data={paragraph} key={key} />;
      }
      case 'ContentfulParagraphIframe': {
        return <IframeBlock data={paragraph} key={key} />;
      }
      case 'ContentfulParagraphDescriptors': {
        return <DescriptorBlock data={descriptors} key={key} />;
      }
      case 'ContentfulCtaSingleCard': {
        return <CTASingleCard data={paragraph} key={key} />;
      }
      case 'ContentfulBiteSize': {
        return <BiteSize data={paragraph} key={key} />;
      }
      case 'ContentfulParagraphFeaturedNews': {
        return (
          <NewsBlock
            key={key}
            data={articles}
            backgroundColor={paragraph.backgroundColour}
            paragraphTitle={paragraph.title}
            category={category}
            isParagraphFeaturedNews
            paddingAbove={paragraph.paddingAbove}
            paddingBelow={paragraph.paddingBelow}
          />
        );
      }
      case 'ContentfulParagraphHtml': {
        return <ParagraphHTML data={paragraph} key={key} />;
      }
      case 'ContentfulImpactSlider': {
        return <ImpactSlider data={paragraph} key={key} />;
      }
      case 'ContentfulParagraphMap': {
        return <ParagraphMap data={paragraph} key={key} />;
      }
      case 'ContentfulWhatYourMoneyDoesCarousel': {
        return <WYMDCarousel data={paragraph} key={key} />;
      }
      case 'ContentfulRichtextCarousel': {
        return <RichtextCarousel data={paragraph} key={key} />;
      }
      case 'ContentfulHeroBanner': {
        return <HeroBanner data={paragraph} key={key} />;
      }
      case 'ContentfulDynamicGallery': {
        return (
          <DynamicGallery
            data={paragraph}
            key={key}
          />
        );
      }
      case 'ContentfulQuoteSlice': {
        return (
          <QuoteSlice
            data={paragraph}
            key={key}
          />
        );
      }
      case 'ContentfulStatsSlice': {
        return (
          <StatsSlice
            data={paragraph}
            key={key}
          />
        );
      }
      case 'ContentfulEmailBanner': {
        return <EmailBanner data={paragraph} key={key} />;
      }
      default: {
        return (
          <div key={key}>
            {singleMessage(paragraph)}
          </div>
        );
      }
    }
  });
};

export default Paragraphs;

Paragraphs.propTypes = {
  paragraphs: PropTypes.oneOfType([PropTypes.shape, PropTypes.array]).isRequired,
  partners: PropTypes.oneOfType([PropTypes.shape, PropTypes.array]),
  people: PropTypes.oneOfType([PropTypes.shape, PropTypes.array]),
  articles: PropTypes.oneOfType([PropTypes.shape, PropTypes.array]),
  moneyBuys: PropTypes.oneOfType([PropTypes.shape, PropTypes.array]),
  descriptors: PropTypes.shape({
    group: PropTypes.arrayOf(
      PropTypes.shape({
        fieldVale: PropTypes.string,
        totalCount: PropTypes.number
      })
    ),
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: PropTypes.shape({
          category: PropTypes.arrayOf(PropTypes.string),
          date: PropTypes.string,
          id: PropTypes.string,
          // richText json format, maybe we need to create a model for this format
          descriptions: PropTypes.objectOf(PropTypes.shape),
          tags: PropTypes.arrayOf(PropTypes.string),
          title: PropTypes.string
        })
      })
    )
  })
};
